var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoUpload = function SvgPhotoUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#213D38",
    fillRule: "evenodd",
    d: "M15.037 26a10 10 0 0 1-.07-1.165 9.5 9.5 0 0 1 .655-3.48 6.034 6.034 0 1 1 6.406-5.73 9.6 9.6 0 0 1 2.474-.325c2.35 0 4.502.85 6.164 2.26V8.668A2.667 2.667 0 0 0 28 6h-5.334l-2.37-3.555A1 1 0 0 0 19.466 2h-6.93a1 1 0 0 0-.832.445L9.333 6H4a2.667 2.667 0 0 0-2.667 2.667v14.666A2.667 2.667 0 0 0 4 26zM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#213D38",
    d: "M20.563 16.149q.07-.398.071-.816a4.633 4.633 0 1 0-4.327 4.624 9.57 9.57 0 0 1 4.256-3.808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3DC869",
    fillRule: "evenodd",
    d: "M24.502 16.7a8.135 8.135 0 1 0 0 16.27 8.135 8.135 0 0 0 0-16.27m-.7 4.076v3.36h-3.36v1.4h3.36v3.358h1.4v-3.359h3.36v-1.4h-3.36v-3.36z",
    clipRule: "evenodd"
  })));
};
export default SvgPhotoUpload;